import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import ReceipeDetail from "./ReceipeDetail";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [product, setProduct] = useState([]);
  const [rmpm, setRmpm] = useState([]);
  const [factory, setFactory] = useState({});
  const [list, setList] = useState([]);
  const { checkRequiredFields } = useRequiredFields();
  const [receipeNotFound, setReceipeNotFound] = useState("");
  const [loading, setLoading] = useState(false);
  const [prevBatchSize, setPrevBatchSize] = useState(1);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        // const resProduct = await Http.get("/receipe-finished-good");
        const resProduct = await Http.get("/product-group-for-dropdown");
        setProduct(resProduct.data);

        // const resRmpm = await Http.get("/rmpm-with-stock?no_stock=1");
        const resRmpm = await Http.get("/product-wise-stock?no_stock=1&type=raw_materials-packaging_materials");
        setRmpm(resRmpm.data.item);

        // const resFactory = await Http.get("/factory");
        // setFactory(resFactory.data);

        const resFactorySelect = await Http.get("/factorySelect2");
        setFactory(resFactorySelect.data);

        const resBatchNo = await Http.get(
          "/last-code-increment-by-one/requisition_productions/batch_no/RP"
        );
        setInputs((values) => ({ ...values, ["batch_no"]: resBatchNo.data }));

        getCurrentDateInput();
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    DatatableFunc();
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));

    if (name === "batch_size") {
      const newBatchSize = parseFloat(value) || 1;

      if (list.length > 0) {
        const ratio = newBatchSize / (prevBatchSize || 1);
        
        const updatedList = list.map((item) => {
          const currentQty = parseFloat(item.qty) || 0;
          return {
            ...item,
            qty: (currentQty * ratio).toFixed(3),
            request_qty: (item.request_qty * ratio).toFixed(3),
          };
        });

        setList(updatedList);
      }

      setPrevBatchSize(newBatchSize);
    }
  };

  const handleCustomInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();

    // get the month in this format of 04, the same for months
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();

    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({ ...values, ["date"]: shortDate }));
    setInputs((values) => ({
      ...values,
      ["expected_production_date"]: shortDate,
    }));

    // Get the current time in the format "HH:mm"
    const hours = ("0" + dateObj.getHours()).slice(-2);
    const minutes = ("0" + dateObj.getMinutes()).slice(-2);

    const defaultTime = `${hours}:${minutes}`;

    setInputs((values) => ({ ...values, ["time"]: defaultTime }));
  };


  const receipeLoad = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption.value;
    setInputs((values) => ({ ...values, [name]: value }));
    setError({});

    setList([]);

    inputs.product_id = value;
    inputs.receipe_type = "fifo";
    Http.post("/receipe-load-product-wise", inputs).then((res) => {
      if (res.data.status == 1) {
        setList(res.data.info.items);
        setReceipeNotFound("");
        setInputs((values) => ({ ...values, ["receipe_id"]: res.data.info.id }));
        setInputs((values) => ({ ...values, ["batch_size"]: res.data.info.batch_size }));
        setPrevBatchSize(parseFloat(res.data.info.batch_size) || 1);

      } else {
        setReceipeNotFound(res.data.msg);
      }
    });
  };
  const addMoreList = (id) => {
    setList((prevList) => {
      const index = prevList.findIndex(
        (item) => Number(item.product_id) === Number(id)
      );

      if (index !== -1) {
        Swal.fire({
          title: "Error!",
          text: "This Product already in the list ! Please choose another RMPM.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return prevList;
      }
      Http.get(`/add-new-rmpm-receipe/${id}?no_stock=1`).then((res) => {
        setList((current) => [
          ...current,
          { ...res.data, request_qty: 1 },
        ]);
      });

      return prevList;
    });
  };





  // Remove List
  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const inputInfo = [...list]; // Load All Existing experience State Data
        inputInfo.splice(index, 1); // Remove Experience by Index/Click Event Wise
        setList(inputInfo); // Replace Existing experience into State
      }
    });
  };

  /*const formSubmit = () => {
    checkRequiredFields();
    inputs.items = list;
    Http.post("/requisition-production", inputs)
      .then((res) => {
        navigate("/requisition-production", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };*/
  const formSubmit = () => {
    checkRequiredFields();

    // Prepare items data only if list has items
    const preparedItems =
      list.length > 0
        ? list.map((item) => ({
          product_id: item.product_id || item.id,
          issue_qty: parseFloat(item.qty) || 0,
          description: item.description || "",
        }))
        : [];

    // Add items to inputs
    const submitData = {
      ...inputs,
      items: preparedItems,
    };

    Http.post("/production", submitData)
      .then((res) => {
        navigate("/production", {
          state: {
            message: res.data.message,
            type: res.data.type || "success",
          },
        });
      })
      .catch(function (e) {
        const responseData = e.response?.data || {};

        if (responseData.errors) {
          setError(responseData.errors);
          return;
        }

        setError(responseData);
      });
  };
  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger 1 small">{error[fieldName]}</div>;
    }
    return null;
  };

  const getStockErrorMessage = () => {
    if (!error?.message || !error?.product_id) {
      return null;
    }

    if (Number(error.product_id) !== Number(inputs.product_id)) {
      return null;
    }

    return <div className="text-danger small">{error.message}</div>;
  };
  const cols = [

    { field: (item) => item.code + "-" + item.name, header: "Item" },
    { field: (item) => item.unit_qty + " " + item.unit_name, header: "Unit" },
    { field: "stockQty", header: "Stock" },
  ];

  const actionTemplate = (item, deleteData) => {

    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Generate Production</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-7">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Generate Production Form
            </h6>
            <hr></hr>
            {/* <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div> */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />

                    {displayError("date")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Time <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="time"
                      value={inputs.time || ""}
                      onChange={handleChange}
                      placeholder="Input Time"
                      data-required
                    />
                    {displayError("time")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Req. No. <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="batch_no"
                      className="form-control"
                      name="batch_no"
                      value={inputs.batch_no || ""}
                      onChange={handleChange}
                      placeholder="Input Batch No"
                      data-required
                    />
                    {displayError("batch_no")}
                  </div>
                </div>
                <div className="row mt-3">

                  <div className="col-lg">
                    <label htmlFor="">
                      Finished Good <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={product[0]}
                      name="product_id"
                      options={product}
                      onChange={receipeLoad}
                      data-required
                    />
                    {displayError("product_id")}
                    {getStockErrorMessage()}
                  </div>
                  <div className="col-lg">
                    <label>
                      Batch Size <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="batch_size"
                      className="form-control"
                      name="batch_size"
                      value={inputs.batch_size || ""}
                      onChange={handleChange}
                      placeholder="Input Batch Size"
                      data-required
                    />
                    {displayError("batch_size")}
                  </div>
                </div>
                {!(inputs.fg_out > 0) && (
                  <div className="row mt-3">
                    <div className="card-solid">
                      <div className="card-header with-border text-center">
                        <h5 className="card-title mb-0">Items List</h5>
                      </div>
                      <div className="card-body mt-3 p-0 pt-3">
                        <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                          <thead>
                            <tr>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Code
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Product
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Request Qty
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Remarks
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from(list).map((x, i) => (
                              <ReceipeDetail
                                key={i}
                                listInfo={x}
                                listSl={i}
                                error={error}
                                rmpm={rmpm}
                                noStockCheck={1}
                                remove={() => removeList(i)}
                                listInputChange={(e) =>
                                  handleCustomInputChange(e, i)
                                }
                              />
                            ))}
                            {receipeNotFound != "" && list.length == 0 ? (
                              <tr>
                                <td colSpan={5}>
                                  <p
                                    style={{ color: "red" }}
                                    className="text-center mt-3"
                                  >
                                    {receipeNotFound}
                                  </p>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="card pd-20 pd-sm-40 col-4"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Raw &amp; Packaging Materials
            </h6>
            <hr></hr>

            <ReactDataTable
              cols={cols}
              receiveData={rmpm}
              isLoading={loading}
              actionTemplate={actionTemplate}
            // deleteData={deleteData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;

